import React from 'react'
import OperationLogoUpdateDialog from './dialogs/OperationLogoUpdateDialog'
import { OperationLogoProvider } from '@agtech/data/operations/OperationDataQueries'

const OperationLogo = (props: { height: number, width: number }) => {
    return (
        <div className='centered wide bg-slate-800 flex'>
            <OperationLogoProvider loading={{ showLoadingText: false }}>
                {(operationLogo) => operationLogo ? (
                    <img
                        title="Operation Logo"
                        src={`data:;base64,${operationLogo}`}
                        height={props.height}
                        width={props.width}
                        className='clickable stretched'
                    />
                ) : (
                    <OperationLogoUpdateDialog.Button
                        text='Upload logo'
                        classes='button-link text-base'
                    />
                )}
            </OperationLogoProvider>
        </div>
    )
}

export default OperationLogo